import austriaGasStations from './gasStations.austria';
import germanyGasStations from './gasStations.germany';

// Austria / Script to assign location and id's to  gas stations, clean up redundant columns from csv/json
// console.log(
//   germanyGasStations
//     .filter((item) => item['Automated Station'] !== 'TRUE')
//     .map((station) => {
//       const location = `${Number(station.Latitude)},${Number(
//         station.Longitude
//       )}`;
//       delete station['Business Wash'];
//       delete station['HGV Suitable'];
//       delete station['Petit Bistrovq'];
//       delete station['Accepts Toll Payments'];
//       delete station['Motorway Site'];
//       delete station['Truck Diesel'];
//       delete station['Fax'];
//       return {
//         ...station,
//         location,
//         IsOpen24Hours: station['Open 24 hours'] === 'TRUE',
//         Brand:
//           station.Brand === 'WE'
//             ? 'Westfalen'
//             : station.Brand === 'AR' || station.Brand === 'RL'
//             ? 'ARAL'
//             : station.Brand === 'TO'
//             ? 'TOTAL'
//             : station.Brand,
//         id: `${Number(station.Latitude)},${Number(station.Longitude)}`,
//       };
//     })
// );

// Germany / Script to assign location and id's to  gas stations, clean up redundant columns from csv/json
// console.log(
//   germanyGasStations
//     .filter((item) => item['Automated Station'] !== 'TRUE')
//     .map((station) => {
//       const location = `${Number(station.Latitude)},${Number(
//         station.Longitude
//       )}`;
//       delete station['Business Wash'];
//       delete station['HGV Suitable'];
//       delete station['Petit Bistrovq'];
//       delete station['Accepts Toll Payments'];
//       delete station['Motorway Site'];
//       delete station['Truck Diesel'];
//       delete station['SiteType'];
//       delete station['SiteType'];
//       delete station['Car Wash'];
//       delete station['Aral FleetPro'];
//       delete station['IFC Data'];
//       delete station['Customer Center ID'];
//       delete station['Aral Truck & Bus Network'];
//       delete station['Suitable for Trucks'];
//       delete station['Business Wash'];
//       delete station['High-Performance Pump'];
//       delete station['AdBlue Canister'];
//       delete station['AdBlue Pump'];
//       delete station['Ultimate'];
//       delete station['Ultimate Diesel'];
//       delete station['Autogas'];
//       delete station['LPG'];
//       delete station['Aral Pulse Charging Station'];
//       return {
//         ...station,
//         location,
//         IsOpen24Hours: station['24 hour?'] === 'Ja',
//         Brand:
//           station.Brand === 'WE'
//             ? 'Westfalen'
//             : station.Brand === 'AR' || station.Brand === 'RL'
//             ? 'ARAL'
//             : station.Brand === 'TO'
//             ? 'TOTAL'
//             : station.Brand,
//         id: `${Number(station.Latitude)},${Number(station.Longitude)}`,
//       };
//     })
// );

export const gasStations = [...austriaGasStations, ...germanyGasStations];

export * from './DamagesList';
export * from './damageDiagramData';
